export default __webpack_public_path__ + "static/media/contact.8709c040.png";